import { useRef } from "react";
import { useEditorState } from "./useEditorState";
import { useQualityModal } from "./useQualityModal";
import { useCanvasInteractions } from "./useCanvasInteractions";
import { useImageUpload } from "./useImageUpload";
import { useResizeCanvasOnGridChange } from "./useResizeCanvasOnGridChange";
import { useDrawCanvas } from "./useDrawCanvas";
import { useGeneratePreviews } from "./useGeneratePreviews";
import { useEditorReset } from "./useEditorReset";
import { useProcessOrder } from "./useProcessOrder";
import { useOrderValidation } from "./useOrderValidation";

export function useCollageEditor() {
  const canvasRef = useRef(null);

  const fileInputRef = useRef(null);

  const {
    toast,
    setToast,

    loading,
    setLoading,

    progress,
    setProgress,

    pieces,
    setPieces,

    img,
    setImg,

    originalFile,
    setOriginalFile,

    scale,
    setScale,

    offset,
    setOffset,

    grid,
    setGrid,

    fileName,
    setFileName,
  } = useEditorState();

  const { qualityModal, setQualityModal, closeQualityModal } =
    useQualityModal();

  const {
    handleMouseDown,
    handleMouseUp,
    handleMouseMove,
    handleTouchStart,
    handleTouchMove,
    handleTouchEnd,
  } = useCanvasInteractions({
    canvasRef,
    img,
    scale,
    setScale,
    setOffset,
  });

  const { handleUpload } = useImageUpload({
    canvasRef,
    grid,
    setImg,
    setOriginalFile,
    setFileName,
    setScale,
    setOffset,
  });

  useResizeCanvasOnGridChange({
    img,
    grid,
    canvasRef,
    setScale,
    setOffset,
  });

  useDrawCanvas({
    canvasRef,
    img,
    scale,
    offset,
    grid,
  });

  useGeneratePreviews({
    canvasRef,
    img,
    scale,
    offset,
    grid,
    setPieces,
  });

  const { resetEditor } = useEditorReset({
    setImg,
    setOriginalFile,
    setPieces,
    setScale,
    setOffset,
    setFileName,
    setQualityModal,
    canvasRef,
    fileInputRef,
  });

  const { processOrder } = useProcessOrder({
    grid,
    scale,
    offset,
    canvasRef,
    img,
    originalFile,
    loading,
    setLoading,
    setToast,
    setProgress,
  });

  const { handleFinishOrder } = useOrderValidation({
    originalFile,
    img,
    canvasRef,
    grid,
    scale,
    setToast,
    setQualityModal,
    processOrder,
    loading,
  });

  const continueLowQualityOrder = () => {
    closeQualityModal();

    setTimeout(() => {
      processOrder();
    }, 0);
  };

  return {
    toast,

    loading,

    progress,

    pieces,

    img,

    scale,
    setScale,

    offset,
    setOffset,

    grid,
    setGrid,

    fileName,

    qualityModal,
    closeQualityModal,

    canvasRef,

    fileInputRef,

    handleUpload,

    handleMouseDown,
    handleMouseUp,
    handleMouseMove,

    handleTouchStart,
    handleTouchMove,
    handleTouchEnd,

    continueLowQualityOrder,

    resetEditor,

    handleFinishOrder,
  };
}
